export default (state = true, action) => {
	switch (action.type) {
		case "mine_finish":
			state = false;
			return state;
		case "mine_display":
			state = true;
			return state ;
		default:
			return state;
	}
};